import { render } from "./novo-candidato.vue?vue&type=template&id=032fe171&scoped=true"
import script from "./novo-candidato.vue?vue&type=script&lang=js"
export * from "./novo-candidato.vue?vue&type=script&lang=js"

import "./novo-candidato.vue?vue&type=style&index=0&id=032fe171&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032fe171"]])

export default __exports__